// extracted by mini-css-extract-plugin
export default {"viewProfile":"viewUser_viewProfile__MSFke","label":"viewUser_label__PZxOn","value":"viewUser_value__4KoM6","userProfileView":"viewUser_userProfileView__fdMss"};